import {BASE_URL} from 'appConstants';

import {get} from 'sdk';

export const fetchIntegrationsStatus = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/integrations/${locationRef}/status/`;

  return get(url, extraGetParams);
};

export const fetchIntegrationsSetupInfo = ({locationRef}) => {
  const url = `${BASE_URL}/v1/integrations/${locationRef}/setup-info/`;

  return get(url);
};

export const fetchActionReportFieldChoices = () => {
  const url = `${BASE_URL}/v1/integrations/action-report/field-choices/`;

  return get(url);
};
